import { ref, type Ref, toValue, watch } from 'vue'

export function useClickWithoutDrag(
    container: Ref<HTMLElement | null>,
    onClick: () => void
): void {
    const hasMouseDown = ref(false)
    const hasDrag = ref(false)

    function onMouseDown(): void {
        hasMouseDown.value = true
    }

    function onMouseUp(): void {
        if (hasMouseDown.value && !hasDrag.value) {
            onClick()
        }

        hasMouseDown.value = false
        hasDrag.value = false
    }

    function onMouseMove(): void {
        hasDrag.value = true
    }

    function onDrag(): void {
        hasDrag.value = true
    }

    function onDragEnd(): void {
        hasDrag.value = false
    }

    watch(hasMouseDown, (n) => {
        const cont = toValue(container)

        if (!cont) {
            return
        }

        if (n) {
            cont.addEventListener('mousemove', onMouseMove, {
                passive: true,
            })

            cont.addEventListener('dragstart', onDrag, {
                passive: true,
            })
            cont.addEventListener('drag', onDrag, {
                passive: true,
            })
            cont.addEventListener('dragend', onDragEnd, {
                passive: true,
            })
        } else {
            cont.removeEventListener('mousemove', onMouseMove)

            cont.removeEventListener('dragstart', onDrag)
            cont.removeEventListener('drag', onDrag)
            cont.removeEventListener('dragend', onDragEnd)
        }
    })

    watch(container, (container, oldContainer) => {
        if (container) {
            container.addEventListener('mousedown', onMouseDown, {
                passive: true,
            })
            container.addEventListener('mouseup', onMouseUp, {
                passive: true,
            })
        }

        if (oldContainer) {
            oldContainer.removeEventListener('mousedown', onMouseDown)
            oldContainer.removeEventListener('mouseup', onMouseUp)
        }
    })
}
